/**
 * Component to display when no routes matches.
 */
const PageNotFound = () => {
  return (
    <div>Requested page is not found.</div>
  )
}

export default PageNotFound;